module.exports = __webpack_public_path__ + "static/media/licenca_verso.24384eda.pdf";